import React, { Component } from "react";
import { connect } from "react-redux";
import * as dataActions from "../../../../_actions/dataActions";
import PageSubTitle from "../../../UI/PageSubTitle";
import EditWidget from "../../../UI/EditWidget";
import Wrapper from "../../../../_hoc/Wrapper";
import Slider from "../../../UI/Slider";
import Select from "../../../UI/Select";
import getMaritalStatus from "../../../../_selectors/dataSelectors/getMaritalStatus";
import getBodyType from "../../../../_selectors/dataSelectors/getBodyType";
import getComplexion from "../../../../_selectors/dataSelectors/getComplexion";
import getDiet from "../../../../_selectors/dataSelectors/getDiet";
import getHabitType from "../../../../_selectors/dataSelectors/getHabitType";
import getMotherTongue from "../../../../_selectors/dataSelectors/getMotherTongue";
import getReligion from "../../../../_selectors/dataSelectors/getReligion";
class Basic extends Component {
  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.preference) {
      const {
        ageEnd,
        ageStart,
        maritalStatus,
        motherTongue,
        complexion,
        bodyType,
        diet,
        smoking,
        drinking,
        religion
      } = nextProps.preference;
      const {
        selectedMaritalStatus,
        selectedMotherTongue,
        selectedComplexion,
        selectedBodyType,
        selectedDiet,
        selectedSmoking,
        selectedDrinking,
        selectedReligion,
        isEditModeOn
      } = prevState;
      if (isEditModeOn) {
        return null;
      } else {
        if (
          ageStart !== prevState.ageStart ||
          ageEnd !== prevState.ageEnd ||
          maritalStatus !== selectedMaritalStatus ||
          motherTongue !== selectedMotherTongue ||
          complexion !== selectedComplexion ||
          bodyType !== selectedBodyType ||
          diet !== selectedDiet ||
          smoking !== selectedSmoking ||
          drinking !== selectedDrinking ||
          religion !== selectedReligion
        ) {
          return {
            ageStart,
            ageEnd,
            selectedBodyType: bodyType,
            selectedComplexion: complexion,
            selectedDiet: diet,
            selectedDrinking: drinking,
            selectedMaritalStatus: maritalStatus,
            selectedMotherTongue: motherTongue,
            selectedSmoking: smoking,
            selectedReligion: religion
          };
        } else {
          return null;
        }
      }
    } else {
      return null;
    }
  }
  state = {
    isEditModeOn: false,
    ageStart: 0,
    ageEnd: 0,
    selectedMaritalStatus: [],
    selectedMotherTongue: [],
    selectedComplexion: [],
    selectedBodyType: [],
    selectedDiet: [],
    selectedSmoking: [],
    selectedDrinking: [],
    selectedReligion: []
  };
  componentDidMount() {
    const {
      maritalStatus,
      getMaritalStatusData,
      bodyType,
      getBodyTypeData,
      complexion,
      getComplexionData,
      diet,
      getDietData,
      habitType,
      getHabitTypeData,
      motherTongue,
      getMotherTongueData,
      religion,
      getReligionData
    } = this.props;
    if (maritalStatus.length === 0) {
      getMaritalStatusData();
    }
    if (bodyType.length === 0) {
      getBodyTypeData();
    }
    if (complexion.length === 0) {
      getComplexionData();
    }
    if (diet.length === 0) {
      getDietData();
    }
    if (habitType.length === 0) {
      getHabitTypeData();
    }
    if (motherTongue.length === 0) {
      getMotherTongueData();
    }
    if (religion.length === 0) {
      getReligionData();
    }
  }
  enableEditMode = () => {
    this.setState({ isEditModeOn: true });
  };
  save = () => {
    const {
      ageStart,
      ageEnd,
      selectedBodyType,
      selectedComplexion,
      selectedDiet,
      selectedDrinking,
      selectedMaritalStatus,
      selectedMotherTongue,
      selectedSmoking,
      selectedReligion
    } = this.state;
    const { update } = this.props;

    const updatedPreference = {
      ageStart,
      ageEnd,
      maritalStatus: selectedMaritalStatus,
      motherTongue: selectedMotherTongue,
      complexion: selectedComplexion,
      bodyType: selectedBodyType,
      diet: selectedDiet,
      smoking: selectedSmoking,
      drinking: selectedDrinking,
      religion: selectedReligion
    };
    const onSuccess = () => {
      this.setState({ isEditModeOn: false });
    };
    const onError = err => {
      console.log(err);
    };
    update({ data: updatedPreference, onSuccess, onError });
  };
  disableEditMode = () => {
    this.setState({ isEditModeOn: false });
  };
  render() {
    const {
      isEditModeOn,
      ageStart,
      ageEnd,
      selectedBodyType,
      selectedComplexion,
      selectedDiet,
      selectedDrinking,
      selectedMaritalStatus,
      selectedMotherTongue,
      selectedSmoking,
      selectedReligion
    } = this.state;
    const {
      maritalStatus,
      bodyType,
      complexion,
      diet,
      habitType,
      motherTongue,
      preference,
      religion
    } = this.props;
    return (
      <Wrapper>
        <PageSubTitle>
          <h3>
            Basic Preference
            <EditWidget
              show
              edit={isEditModeOn}
              onEdit={this.enableEditMode}
              onSave={this.save}
              onCancel={this.disableEditMode}
              disabled={preference.cache}
            />
          </h3>
          <p />
        </PageSubTitle>
        <div className="form-group-one-unit">
          <div className="row">
            <div className="col-md-12">
              <Slider
                min={21}
                max={80}
                defaultValue={[0, 0]}
                value={[ageStart, ageEnd]}
                label={<Wrapper>Age</Wrapper>}
                multi
                readOnly={!isEditModeOn}
                onChange={(start, end) => {
                  this.setState({ ageStart: start, ageEnd: end });
                }}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-md-4">
              <Select
                label={<Wrapper>Marital Status</Wrapper>}
                selected={selectedMaritalStatus}
                options={maritalStatus}
                onChange={value => {
                  this.setState({ selectedMaritalStatus: value });
                }}
                clearable={false}
                searchable={true}
                placeholder="ANUP"
                multi
                readOnly={!isEditModeOn}
              />
            </div>
            <div className="col-md-4">
              <Select
                label={<Wrapper>Religion</Wrapper>}
                selected={selectedReligion}
                options={religion}
                onChange={value => {
                  this.setState({ selectedReligion: value });
                }}
                clearable={false}
                searchable={true}
                placeholder="ANUP"
                multi
                readOnly={!isEditModeOn}
              />
            </div>
            <div className="col-md-4">
              <Select
                label={<Wrapper>Mother Tongue</Wrapper>}
                selected={selectedMotherTongue}
                options={motherTongue}
                onChange={value => {
                  this.setState({ selectedMotherTongue: value });
                }}
                clearable={false}
                searchable={true}
                placeholder="ANUP"
                multi
                readOnly={!isEditModeOn}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-md-6">
              <Select
                label={<Wrapper>Complexion</Wrapper>}
                selected={selectedComplexion}
                options={complexion}
                onChange={value => {
                  this.setState({ selectedComplexion: value });
                }}
                clearable={false}
                searchable={true}
                placeholder="ANUP"
                multi
                readOnly={!isEditModeOn}
              />
            </div>
            <div className="col-md-6">
              <Select
                label={<Wrapper>Body Type</Wrapper>}
                selected={selectedBodyType}
                options={bodyType}
                onChange={value => {
                  this.setState({ selectedBodyType: value });
                }}
                clearable={false}
                searchable={true}
                placeholder="ANUP"
                multi
                readOnly={!isEditModeOn}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-md-4">
              <Select
                label={<Wrapper>Diet</Wrapper>}
                selected={selectedDiet}
                options={diet}
                onChange={value => {
                  this.setState({ selectedDiet: value });
                }}
                clearable={false}
                searchable={true}
                placeholder="ANUP"
                multi
                readOnly={!isEditModeOn}
              />
            </div>
            <div className="col-md-4">
              <Select
                label={<Wrapper>Smoking</Wrapper>}
                selected={selectedSmoking}
                options={habitType}
                onChange={value => {
                  this.setState({ selectedSmoking: value });
                }}
                clearable={false}
                searchable={true}
                placeholder="ANUP"
                multi
                readOnly={!isEditModeOn}
              />
            </div>
            <div className="col-md-4">
              <Select
                label={<Wrapper>Drinking</Wrapper>}
                selected={selectedDrinking}
                options={habitType}
                onChange={value => {
                  this.setState({ selectedDrinking: value });
                }}
                clearable={false}
                searchable={true}
                placeholder="ANUP"
                multi
                readOnly={!isEditModeOn}
              />
            </div>
          </div>
        </div>
      </Wrapper>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  maritalStatus: getMaritalStatus(state),
  bodyType: getBodyType(state),
  complexion: getComplexion(state),
  diet: getDiet(state),
  habitType: getHabitType(state),
  motherTongue: getMotherTongue(state),
  religion: getReligion(state)
});
const mapDispatchToProps = dispatch => ({
  getMaritalStatusData: () => dispatch(dataActions.getMaritalStatus()),
  getBodyTypeData: () => dispatch(dataActions.getBodyType()),
  getComplexionData: () => dispatch(dataActions.getComplexion()),
  getDietData: () => dispatch(dataActions.getDiet()),
  getHabitTypeData: () => dispatch(dataActions.getHabitType()),
  getMotherTongueData: () => dispatch(dataActions.getMotherTongue()),
  getReligionData: () => dispatch(dataActions.getReligion())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Basic);



// WEBPACK FOOTER //
// ./src/_components/Profile/PartnerPreference/Basic/index.js